import {format, parseISO} from 'date-fns';
export function FormatDate(date: string) {
  const d = parseISO(date);
  return format(d, "dd.MM.yyyy. '|' HH:mm");
}